import React from "react";
import { MainContainer } from "./styled";
import { Grid } from "@mui/material";

const MainLayout = ({ children }: any) => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <MainContainer>{children}</MainContainer>
        </Grid>
      </Grid>
    </>
  );
};

export default MainLayout;
